import type { FC } from 'react';
import { useState } from 'react';
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Collapse,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import TableRowBody from '../../../components/global/TableRowBody';

const RowFuvex: FC<{ item: any }> = ({ item }) => {
  const [open, setOpen] = useState(item.detail?.open);
  const keyDetailHead = `detail-fuvex-h-${item.id}`;
  const keyDetailFoot = `detail-fuvex-f-${item.id}`;

  return (
    <>
      <TableRowBody key={item.id}>
        <TableCell align="center" width={400}>
          {item.fuvex}
          {item.detail && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell align="center" width={250}>
          {item.vendedoresTotal}
        </TableCell>
        <TableCell align="center">{item.vendedoresDiario}</TableCell>
        <TableCell align="center" width={250}>
          {item.semaforoActivo}
          %
        </TableCell>
        <TableCell align="center" width={200}>
          {item.consultaAcumulado}
        </TableCell>
        <TableCell align="center" width={250}>
          {item.promConsultaDiario}
        </TableCell>
        <TableCell align="center" width={100}>
          <img
            src={`/static/images/${item.semaforo}.png`}
            alt={item.semaforo}
          />
        </TableCell>
      </TableRowBody>
      {item.detail && (
        <>
          <TableRowBody key={keyDetailHead}>
            <TableCell
              colSpan={7}
              style={{ display: open ? 'table-cell' : 'none', padding: 0 }}
            >
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Table size="small" style={{ background: 'white' }}>
                  <TableBody>
                    {item.detail?.data?.map((detail) => (
                      <TableRow key={detail.id}>
                        <TableCell align="center" width={400}>
                          {detail.name}
                        </TableCell>
                        <TableCell align="center" width={250}>
                          {detail.vendedoresTotal}
                        </TableCell>
                        <TableCell align="center">
                          {detail.vendedoresDiario}
                        </TableCell>
                        <TableCell align="center" width={250}>
                          {detail.semaforoActivo}
                          %
                        </TableCell>
                        <TableCell align="center" width={200}>
                          {detail.consultaAcumulado}
                        </TableCell>
                        <TableCell align="center" width={250}>
                          {detail.promConsultaDiario}
                        </TableCell>
                        <TableCell align="center" width={100}>
                          <img
                            src={`/static/images/${detail.semaforo}.png`}
                            alt={detail.semaforo}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Collapse>
            </TableCell>
          </TableRowBody>
          <TableRowBody key={keyDetailFoot}>
            <TableCell colSpan={7} style={{ display: 'none' }} />
          </TableRowBody>
        </>
      )}
    </>
  );
};

export default RowFuvex;
